if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        // ❌ Disable default hidden variant selector input
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = true;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      // 🔍 Get first available variant from DOM (with min="1")
      getFirstAvailableVariantId() {
        const items = document.querySelectorAll('.custom_product_deatils_item');
        for (let item of items) {
          const quantityInput = item.querySelector('.quantity__input');
          const isAvailable = quantityInput?.hasAttribute('min') && quantityInput.getAttribute('min') === "1";
          if (isAvailable) {
            return item.getAttribute('data-vid');
          }
        }
        return null;
      }
      // 🧠 Get all variants where quantity > 0
      getSelectedAddons() {
        const selectedItems = [];
        const addonItems = document.querySelectorAll('.custom_product_deatils_item');

        addonItems.forEach((item) => {
          const quantityInput = item.querySelector('.quantity__input');
          const quantity = parseInt(quantityInput.value, 10);
          const variantId = item.getAttribute('data-vid');

          if (quantity > 0) {
            selectedItems.push({
              id: variantId,
              quantity: quantity
            });
          }
        });

        return selectedItems;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const selectedItems = this.getSelectedAddons();
        const firstAvailableId = this.getFirstAvailableVariantId();

      
        const firstVariant = selectedItems.find(item => item.id === firstAvailableId && item.quantity === 1);
        const otherVariantsSelected = selectedItems.filter(item => item.id !== firstAvailableId && item.quantity > 0);

       if (selectedItems.length === 0) {
          this.handleErrorMessage("Please select at least one format to add.");
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }
        
        if (selectedItems.length > 1) {
          // Multiple variants selected → bulk add
          selectedItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
        } else {
          // Only one variant selected
          formData.append('id', selectedItems[0].id);
          formData.append('quantity', selectedItems[0].quantity);
        }


        // 📦 Section Rendering for cart updates
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error)
              this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
